// import React from 'react';
// import { styled, Select } from '@mui/material';

// const CustomSelect = styled((props) => <Select {...props} />)();

// export default CustomSelect;

import React from "react";
import { Select } from "@mui/material";

const CustomSelect = (props) => <Select {...props} />;

export default CustomSelect;
